import { useState } from 'react';
import { NewAudit } from './NewAudit';
import { AuditQueue } from './AuditQueue';

/**
 * Home - Unified home screen (spec audit-review-console): console hero,
 * the New Audit form, and the review queue below it, all on one screen.
 *
 * Completing a run does not navigate away — it stays on this screen and
 * bumps `refreshKey` so AuditQueue refetches and shows the new run at the
 * top, with a brief inline confirmation next to the form.
 */

const SparklesIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z" />
  </svg>
);

export function Home({ onOpenTrace }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [justCompleted, setJustCompleted] = useState(false);

  function handleComplete() {
    setJustCompleted(true);
    setRefreshKey((key) => key + 1);
  }

  return (
    <>
      <div className="hero">
        <div className="powered-badge">
          <SparklesIcon />
          <span>Powered by AI</span>
        </div>
        <h1>Audit <span>Console</span></h1>
      </div>

      <NewAudit onComplete={handleComplete} hideHero />

      {justCompleted && (
        <div className="priority-banner">
          Audit completed — see it in the queue below.
        </div>
      )}

      <AuditQueue onOpenTrace={onOpenTrace} refreshKey={refreshKey} />
    </>
  );
}
